<template>
  <el-table :data="formatData" :row-style="showRow" v-bind="$attrs">
    <template slot="empty">
      <div class="newTableEmpty">暂无数据，去<span @click="addNewOpen">新建</span></div>
    </template>
    <el-table-column v-if="columns.length === 0" width="150">
      <template slot-scope="scope">
        <span
                v-for="space in scope.row._level"
                class="ms-tree-space"
                :key="space"
        ></span>
        <span
                class="tree-ctrl"
                v-if="iconShow(0, scope.row)"
                @click="toggleExpanded(scope.$index)"
        >
          <i v-if="!scope.row._expanded" class="el-icon-arrow-right"></i>
          <i v-else class="el-icon-arrow-down"></i>
        </span>
        {{ scope.$index }}
      </template>
    </el-table-column>
    <el-table-column
            v-else
            v-for="(column, index) in columns"
            :key="column.value"
            :label="column.text"
            :width="column.width"
    >
      <template slot-scope="scope">
        <span
                v-for="space in scope.row._level"
                class="ms-tree-space"
                v-show="column.value == 'name'"
                :key="space"
        ></span>
        <span
                class="tree-ctrl"
                v-if="iconShow(index, scope.row)"
                @click="toggleExpanded(scope.$index)"
        >
          <i v-if="!scope.row._expanded" class="el-icon-arrow-right"></i>
          <i v-else class="el-icon-arrow-down"></i>
        </span>
        <span
                v-show="
            scope.row[column.value] != 'button' && column.value != 'status' && scope.row[column.value] != 'one' &&column.value != 'create_time'
          "
        >{{ scope.row[column.value] }}</span
        >
        <span v-show="column.value == 'create_time'">
          {{ scope.row['dataViewRange'] === 0 ? '全部':scope.row['dataViewRange'] == 1?'仅看本业务区域':''}}
        </span>
        <span
                v-show="column.value == 'status'"
                style="cursor: pointer;color:#1980ff;"
        >
          <!-- {{
            scope.row['status'] == 1
              ? '启用'
              : scope.row['status'] === 0
              ? '禁用'
              : ''
          }} -->
          <el-switch
                  :value="scope.row['status'] == 1 ? true : false"
                  @change="changeStatus(scope.row)"
                  v-show="scope.row['status'] !== ''">
          </el-switch>
          </span
          >
        <!-- <span v-show="scope.row[column.value] == 'one'"><div class="op-link" @click="openEditDialog(scope.row)">编辑</div></span> -->
        <span v-show="scope.row[column.value] == 'button' || scope.row[column.value] == 'one'">
          <div class="op-link editColor" @click="openEditDialog(scope.row)" v-show="btnType.edit">编辑</div>
          <div class="op-link">
            <el-dropdown trigger="click" @command="handleCommand" v-show="btnType.move" @click="handClick(scope.row)">
              <span class="el-dropdown-link">移动</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="composeValue(scope.row, '上移')">上移</el-dropdown-item>
                <el-dropdown-item :command="composeValue(scope.row, '下移')">下移</el-dropdown-item>
                <el-dropdown-item :command="composeValue(scope.row, '升序')">升序</el-dropdown-item>
                <el-dropdown-item :command="composeValue(scope.row, '降序')">降序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="op-link deleteColor" v-show="btnType.del" @click="confirmDelete(scope.row)">删除</div>
        </span>
      </template>
    </el-table-column>
    <slot></slot>
  </el-table>
</template>

<script>
  import treeToArray from './eval'
  export default {
    name: 'treeTable',
    props: {
      data: {
        type: [Array, Object],
        required: true,
      },
      btnType:{
        type:Object,
        required: true,
      },
      columns: {
        type: Array,
        default: () => [],
      },
      evalFunc: Function,
      evalArgs: Array,
      expandAll: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      // 格式化数据源
      formatData: function () {
        let tmp
        if (!Array.isArray(this.data)) {
          tmp = [this.data]
        } else {
          tmp = this.data
        }
        const func = this.evalFunc || treeToArray
        const args = this.evalArgs
                ? Array.concat([tmp, this.expandAll], this.evalArgs)
                : [tmp, this.expandAll]
        return func.apply(null, args)
      },
    },
    mounted(){
      // console.log(this.columns, this.formatData, '====还是会水水水水水水', this.btnType)
    },
    methods: {
      showRow: function (row) {
        const show = row.row.parent
                ? row.row.parent._expanded && row.row.parent._show
                : true
        row.row._show = show
        return show
                ? 'animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;'
                : 'display:none;'
      },
      // 切换下级是否展开
      toggleExpanded: function (trIndex) {
        const record = this.formatData[trIndex]
        record._expanded = !record._expanded
      },
      //修改数据状态
      changeStatus(row) {
        row.status = row.status == 1 ? 0 : row.status == 0 ? 1 : ''
        this.$emit('changeStatus',row)
      },
      // 点击新建
      addNewOpen () {
        this.$emit('openAddDialog')
      },
      //数据删除
      confirmDelete(row){
        this.$emit('deleteInfo',row)
      },
      //移动传递参数
      handleCommand(command){
        this.$emit('moveInfo',command)
      },
      //下拉菜单参数多传
      composeValue(row,command){
        return{
          'row':row,
          'command':command
        }
      },
      //编辑  向父组件传递数据
      openEditDialog(row){
        var list = new Object()
        list.businessArea = row.businessArea
        list.comment = row.comment
        list.dataViewRange = row.dataViewRange
        list.id = row.id
        list.name = row.name
        list.parentId = row.parentId
        list.remark = row.remark
        list.status = row.status
        list.types = row.types
        this.$emit('getRow',list)
      },
      // 控制图标显示
      iconShow(index, record) {
        return index === 0 && record.children && record.children.length > 0
      },
    },
  }
</script>
<style rel="stylesheet/css" scoped>
  @keyframes treeTableShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes treeTableShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>

<style scoped>
  .ms-tree-space {
    position: relative;
    top: 1px;
    display: inline-block;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    width: 18px;
    height: 14px;
  }
  .ms-tree-space::before {
    content: '';
  }
  .processContainer {
    width: 100%;
    height: 100%;
  }
  table td {
    line-height: 26px;
  }
  .op-link >>> .el-dropdown-link {
    display: inline-block;
    color: #1980ff;
    cursor: pointer;
    margin: 0 5px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  .tree-ctrl {
    position: relative;
    cursor: pointer;
    color: #2196f3;
    margin-left: -18px;
  }
</style>
